const style = {
  clients: {
    backgroundColor: '#fff',
    minHeight: '100%',
  },
};

export default style;
